import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c2, r2, sImaginary) {
  var result = Complex.createComplex(0, sImaginary * c2 * r2).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexFFDenominator, c2, c5, r2, rOut, sImaginary, sSquared) {
  var complexFFNumerator = Complex.createComplex(sSquared * rOut * c2 * c5 * r2, sImaginary * rOut * (c2 + c5));
  var result = complexFFNumerator.divide(complexFFDenominator);
  return result;
}
